'use client';

import dynamic from 'next/dynamic';
import { useIsAppRouter } from '~/context/common/StaticContext';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';

const TrackPageExit = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrackPageExit" */ '@/vdp/Analytics/TrackPageExit'
    ),
  { ssr: false }
);

const VehicleDetailsStandardContainer = dynamic(
  () =>
    import(
      /* webpackChunkName: "VehicleDetailsStandardContainer" */ '@/vdp/VehicleDetailsContainer/VehicleDetailsStandardContainer'
    )
);

const VehicleDetailsLiteContainer = dynamic(
  () =>
    import(
      /* webpackChunkName: "VehicleDetailsLiteContainer" */ '@/vdp/VehicleDetailsContainer/VehicleDetailsLiteContainer'
    )
);

export default function VehicleDetailsContainer() {
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isAppRouter = useIsAppRouter();

  return (
    <>
      {isAppRouter && <TrackPageExit />}
      {isCampaignTemplateOne ? (
        <VehicleDetailsLiteContainer />
      ) : (
        <VehicleDetailsStandardContainer />
      )}
    </>
  );
}
